export const ROLE_ANAESTHETIST = 'anaesthetist'
export const ROLE_SURGEON_SECRETARY = 'surgeon_secretary'
export const ROLE_SECRETARY_ANAESTHETIST = 'secretary_anesthetist'
export const ROLE_ADMIN = 'admin'

const roleAliases = {
  anesthetist: ROLE_ANAESTHETIST,
  secretary_surgeon: ROLE_SURGEON_SECRETARY,
  super_admin: ROLE_ADMIN,
}

export const normalizeRole = value => {
  if (!value)
    return ''

  const normalized = String(value)
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/-/g, '_')
    .replace(/^role_/, '')

  return roleAliases[normalized] ?? normalized
}
